import type { ImageValue } from '@elfsight/configurator-contracts';
import type { IconProps as IconComponentProps } from '@elfsight/widget-ui';
import { Icon as IconComponent } from '@elfsight/widget-ui';

interface IconProps extends IconComponentProps {
  icon: ImageValue;
}

export function Icon({
  icon,
  size = 24,
  fill = 'currentColor',
  ...restProps
}: IconProps) {
  if (!icon?.url) return null;

  return (
    <IconComponent src={icon.url} size={size} fill={fill} {...restProps} />
  );
}
